import { fork, takeEvery, put, select, call } from 'redux-saga/effects';
import types from './types';
import UserActions from '../User/actions';
import RulesActions from '../Rules/actions';
import GameActions from './actions';
import { SettingsActions } from '../Settings';
import { SessionsActions } from '../Sessions';
import { difficultyArray } from '../../data/difficulty';

function* handleNextPhase(context) {
  const { ReactGa, apiService } = context;
  yield put(GameActions.setPhaseLoading(true));

  const {
    user: { sessionToken },
    settings: { difficulty, numberOfPlayers },
    game,
  } = yield select((state) => state);

  const { currentPhase } = game;
  yield put(SettingsActions.setShowPhaseModal(true));
  try {
    const state = yield call(apiService.nextPhase, {
      sessionToken,
      difficulty,
      oldPhase: currentPhase,
      numberOfPlayers,
    });

    yield put(UserActions.restoreUser(state.user));
    yield put(SettingsActions.restoreSettings(state.settings));
    yield put(GameActions.restoreGame(state.game));
    yield put(RulesActions.restoreRules(state.rules));

    ReactGa.event({
      category: 'Play',
      action: 'Moved to next Phase',
      value: state.game.phase,
    });

    yield put(GameActions.setPhaseLoading(false));
  } catch (e) {
    yield put(GameActions.setPhaseLoading(false));
  }
}

function* handleStartGame(context) {
  const { ReactGa, apiService } = context;
  yield put(GameActions.setPhaseLoading(true));

  const {
    user: { sessionToken, sessionName },
    settings: { difficulty, numberOfPlayers },
    game,
  } = yield select((state) => state);

  const { players, gameMode } = game;
  const playerSetup = [];
  for (let p = 0; p < numberOfPlayers; p += 1) {
    playerSetup.push({
      playedClass: players[p].playedClass,
      displayName: players[p].displayName,
    });
  }

  const state = yield call(apiService.startGame, {
    sessionToken: sessionToken || 'newGame',
    difficulty,
    playerSetup,
    sessionName,
    gameMode,
  });

  yield put(
    SessionsActions.addSession({
      sessionName,
      sessionToken: state.user.sessionToken,
    }),
  );

  yield put(UserActions.restoreUser(state.user));
  yield put(SettingsActions.restoreSettings(state.settings));
  yield put(GameActions.restoreGame(state.game));
  yield put(RulesActions.restoreRules(state.rules));
  yield put(GameActions.setPhaseLoading(false));

  ReactGa.event({
    category: 'Play',
    action: 'Started a game',
  });

  yield put(UserActions.setShowLoginModal(true));
}

function* handleTogglePhaseGoal(context, { data }) {
  const {
    game: { currentPhase },
    user: { sessionToken },
  } = yield select((state) => state);

  const { ReactGa, apiService } = context;
  ReactGa.event({
    category: 'Play',
    action: 'Toggled phase goal',
    value: currentPhase,
  });

  const { newState } = yield call(apiService.togglePhaseGoal, {
    phaseGoal: data,
    sessionToken,
  });

  yield put(GameActions.restoreGame(newState.game));
}

function* handleRestartGame(context) {
  const {
    user: { sessionToken },
  } = yield select((state) => state);

  const { apiService } = context;
  const state = yield call(apiService.restartGame, { sessionToken });
  yield put(UserActions.restoreUser(state.user));
  yield put(SettingsActions.restoreSettings(state.settings));
  yield put(GameActions.restoreGame(state.game));
  yield put(RulesActions.restoreRules(state.rules));
}

function* handleSetGameMode() {
  const {
    user: { sessionToken },
    game: { currentPhase, gameMode },
  } = yield select((state) => state);
  if (sessionToken === '' && currentPhase === 0) {
    if (gameMode === 'hard') {
      yield put(GameActions.setUnlockedDifficulties([difficultyArray[0]]));
      yield put(SettingsActions.setDifficulty(difficultyArray[0]));
    } else {
      yield put(GameActions.setUnlockedDifficulties(difficultyArray));
    }
  }
}

// **** WATCHERS ****
function* watchStartGame(context) {
  yield takeEvery(types.START_GAME, handleStartGame, context);
}

function* watchNextPhase(context) {
  yield takeEvery(types.NEXT_PHASE, handleNextPhase, context);
}

function* watchTogglePhaseGoal(context) {
  yield takeEvery(types.SET_PHASE_GOAL_STATE, handleTogglePhaseGoal, context);
}

function* watchRestartGame(context) {
  yield takeEvery(types.RESTART_GAME, handleRestartGame, context);
}

function* watchSetGameMode(context) {
  yield takeEvery(types.SET_GAME_MODE, handleSetGameMode, context);
}

export default (context) => [
  fork(watchStartGame, context),
  fork(watchNextPhase, context),
  fork(watchTogglePhaseGoal, context),
  fork(watchRestartGame, context),
  fork(watchSetGameMode, context),
];
